import { Component, ViewChild, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Menu, MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { LocaleService } from '../locale.service';
import { LocaleCode } from '../locale.types';

@Component({
  selector: 'app-locale-picker',
  standalone: true,
  imports: [MenuModule, AsyncPipe],
  templateUrl: './locale-picker.component.html',
  styleUrl: './locale-picker.component.css'
})
export class LocalePickerComponent {
  private readonly localeService = inject(LocaleService);

  @ViewChild('menu') menu!: Menu;

  readonly current$ = this.localeService.current$;

  readonly items: MenuItem[] = this.localeService.available.map(locale => ({
    label: locale.label,
    command: () => this.localeService.setLocale(locale.code)
  }));

  toggle(event: Event): void {
    this.menu.toggle(event);
  }

  labelOf(code: LocaleCode): string {
    return this.localeService.available.find(l => l.code === code)?.label ?? code;
  }
}
